import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FileService } from 'src/app/services/file.service';
import { OrderService } from 'src/app/services/order.service';
import { saveAs } from 'file-saver';
//import { startOfDay, endOfDay, subDays } from 'date-fns';
import { CommonService } from 'src/app/services/common.service';
import { CustomerService } from 'src/app/services/customer.service';
import { TranslateService } from '@ngx-translate/core';
import { HttpResponse } from '@angular/common/http';
import * as JSZip from 'jszip';
import { SharedDataService } from 'src/app/services/sharedDataService.service';
import { environment } from 'src/environments/environment';
interface FinancialData {
  id: number;
  deliveryNote: string;
  invoice: string;
  dueDate: string;
  amountDisplay: any;
  text: string;
  status: string;
  overDueDays:number;
}

@Component({
  selector: 'app-financial-data',
  templateUrl: './financial-data.component.html',
  styleUrls: ['./financial-data.component.less'],
})
export class FinancialDataComponent implements OnInit {
  @Input() tabSelectedIndex: number | undefined;
  creditObj: any = {};
  searchFormData!: FormGroup;
  exportLoading:boolean = false;
  isReset:boolean = false;
  financialListData: FinancialData[] = [];
  pagination = {
    total: 0,
    pageIndex: 1,
    pageSize: 10,
    pageSizeOptions: [10, 20, 50],
  };
  isSpinning = true;
  codeTypeList:any=[];
  statusList:any=[];
  isDealerPortal: boolean = false;
  constructor(
    private fb: FormBuilder,
    private orderService: OrderService,
    private fileService: FileService,
    private commonService: CommonService,
    private customerService: CustomerService,
    private translate:TranslateService,
    private sharedData: SharedDataService,
  ) {
    this.sharedData.currentData.subscribe(data => {
      this.isDealerPortal = data.isDealerPortal;
    });
  }
  ngOnInit(): void {
    this.searchFormData = this.fb.group({
      dueDate: [[], []],
      orderStatus: ['', []],
      keywordsType: ['invoice', []],
      keywords: ['', []],
    });
    this.updateData();
    this.translate.onLangChange.subscribe(() => {
      if(this.tabSelectedIndex==3){
      this.updateData();
      }
    });
    this.customerService.selectedCustomer$.subscribe(() => {
      if(this.tabSelectedIndex==3){
        this.getCreditLimit();
      }
    });
  }

  updateData():void{
    this.codeTypeList=   [
      { name: this.translate.instant("REFERENCE_INVOICE"), value: 'invoice' },
      { name: this.translate.instant("OVERDUE_DAYS"), value: 'overDueDays' },
    ];
    this.statusList = [
      { name: this.translate.instant('DUE'), value: 'Due' },
      { name: this.translate.instant('OVERDUE'), value: 'OverDue' },
    ];
    this.getCreditLimit();
  }

  
  //get credit limit
  getCreditLimit() {
    this.orderService.getCreditLimit().subscribe((result) => {
        this.creditObj = result.rtnData;
        this.getList();
    });
    
  }
  onInputEnter(event: any): void {
    event.preventDefault();
    this.getList();
  }
  changeKeywords(){
    this.searchFormData.get('keywords')?.setValue('');
  }
  getList() {
    this.isSpinning = true;
    const dynamicObject: { [key: string]: string } = {
      [this.searchFormData.value.keywordsType]:
        this.searchFormData.value.keywords,
    };
    let params = {
      ...dynamicObject,
      size: this.pagination.pageSize,
      current: this.pagination.pageIndex,
      dueDateEnd: this.searchFormData.value.dueDate
        ? this.commonService.formatDateString(this.searchFormData.value.dueDate[1]) ?? ''
        : '',
      dueDateStart: this.searchFormData.value.dueDate
        ? this.commonService.formatDateString(this.searchFormData.value.dueDate[0]) ?? ''
        : '',
      status: this.searchFormData.value.orderStatus,
    };
    this.orderService.queryFinancialData(params).subscribe((result: any) => {
      const { rtnCode, rtnData } = result;
      if (rtnCode === 10000) {
        this.financialListData = rtnData;
        this.pagination.total = 0;
      }
      this.isSpinning = false;
    });
    if(environment.production) {
      const userData = JSON.parse(localStorage.getItem('userData') || '{}');
      const customer = JSON.parse(localStorage.getItem('customer') || '{}');
      const keysString = Object.keys(params).join(',');
      const valuesString = Object.values(params)
        .map(value => {
          // 如果值是数组（如 orderType），先转为字符串，或者根据需求处理 null/undefined
          if (Array.isArray(value)) {
            return value.join('|'); // 数组内部建议用不同分隔符，以免混淆
          }
          return value ?? ''; // 处理 null 或 undefined
        })
        .join(',');
      (window as any).dataLayer.push({
        event: 'dp_financial_data_filter_click',
        from_page: (localStorage.getItem('token') ? 'afterLogin ' : 'beforeLogin ') + window.location.pathname,
        event_type: keysString,
        event_name: '',
        portal_name: this.isDealerPortal ? "DealerPortal " + customer?.customerCode : "SalesPortal " + userData?.queryUserPageInfoResDTO?.ntAccount,
        event_content: valuesString,
      });
    }
  }
  clear():void{
    this.isReset = true;
    this.searchFormData.reset({
      dueDate: [],
      orderStatus: '',
      keywordsType: 'invoice',
      keywords: ''
    });
    this.getList();
    this.isReset = false;
  }
  //export
  exportExcel(): void {
    this.exportLoading = true;
    this.fileService
      .exportToExcel(
        `/eshop_backend/financial/export?${this.searchFormData.value.keywordsType}=${
          this.searchFormData.value.keywords
        }&dueDateEnd=${
          this.searchFormData.value.dueDate
            ? this.commonService.formatDateString(this.searchFormData.value.dueDate[1]) ?? ''
            : ''
        }&dueDateStart=${
          this.searchFormData.value.dueDate
            ? this.commonService.formatDateString(this.searchFormData.value.dueDate[0]) ?? ''
            : ''
        }&status=${
          this.searchFormData.value.orderStatus
            ??''
        }`
      )
      .subscribe(
        async (response: HttpResponse<Blob>) => {
          const unzipped = await JSZip.loadAsync(response.body!); //  ZIP
          // map the unzip file
          for (const [filename, fileObj] of Object.entries(unzipped.files)) {
            if (filename.endsWith('.xlsx') || filename.endsWith('.xls')) {
              const excelData = await fileObj.async('blob'); // read as Blob
              saveAs(excelData, decodeURIComponent(filename));
            }
          }
          this.exportLoading = false;
        },
        (error: any) => {
          console.error('Error exporting Excel:', error);
        }
      );
    if (environment.production) {
      const userData = JSON.parse(localStorage.getItem('userData') || '{}');
      const customer = JSON.parse(localStorage.getItem('customer') || '{}');
      (window as any).dataLayer.push({
        event: 'dp_order_download_click',
        from_page: (localStorage.getItem('token') ? 'afterLogin ' : 'beforeLogin ') + window.location.pathname,
        event_type: 'financial status',
        event_name: 'order download',
        portal_name: this.isDealerPortal ? "DealerPortal " + customer?.customerCode : "SalesPortal " + userData?.queryUserPageInfoResDTO?.ntAccount,
        event_content: this.searchFormData.value.orderStatus,
      });
    }
  }
  handleChange(e: Event): void {
    if(!this.isReset){
      this.pagination.pageIndex = 1;
      this.getList();
    }
  }
  pageSizeChange(pageSize: number) {
    this.pagination.pageSize = pageSize;
    this.pagination.pageIndex = 1;
    this.getList();
  }

  pageIndexChange(pageIndex: number) {
    this.pagination.pageIndex = pageIndex;
    this.getList();
  }
}
